import { RoomApiRoomDeleteRequest } from "../../openapi/api";
import appApiClient from "./coreApiClient";
import useBaseMutation from "./useBaseMutation";

export const useRoomDeleteMutation = () =>
  useBaseMutation({
    mutationFn: (req: RoomApiRoomDeleteRequest, config) =>
      appApiClient.roomApi.roomDelete(req, config),
  });
